import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getProperties, getProperty } from "../services/property";

export function useGetProperties() {
  return useQuery({
    queryKey: ["properties"],
    queryFn: () => getProperties(),
    staleTime: 1000 * 60 * 60,
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}

export function useGetProperty(id: string) {
  return useQuery({
    queryKey: ["property", id],
    queryFn: () => getProperty(id),
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
